export const QUEUES_ITEMS_PER_PAGE = 50;

export const sqsQueuesFields = {
    queue: "queue",
    total: "total",
    in_progress: "in_progress",
    lag: "lag",
};
